import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=84bc8c0c&"
import script from "./pageHeader.vue?vue&type=script&lang=js&"
export * from "./pageHeader.vue?vue&type=script&lang=js&"
import style0 from "./pageHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports